export enum LastDealsTableColumnId {
  VOLUME = 3,
  PRICE = 4,
  DEAL_NUMBER = 5,
  TIME = 6,
  DATE = 7,
}

export type LastDealsTableColumn = {
  id: LastDealsTableColumnId;
  name: string;
  cellSizeMin?: string;
  cellSizeMax?: string;
};

export type LastDealsTableSorting = {
  columnId: LastDealsTableColumnId;
  direction: 'ASC' | 'DESC';
};
